import { render } from "./questionFive.vue?vue&type=template&id=4249fc0b"
import script from "./questionFive.vue?vue&type=script&lang=ts"
export * from "./questionFive.vue?vue&type=script&lang=ts"

import "./questionFive.vue?vue&type=style&index=0&id=4249fc0b&lang=css"
script.render = render

export default script